import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";

const entryAnimation = keyframes`${zoomIn}`;

export const StepsMainContainer = styled.div`
  position: static;
  float: right;
  width: 30%;
  top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 500px;
  animation: 1.5s ${entryAnimation};
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
